export const summaryRows: Array<[string, string]> = [
  ['6 tomos completos', 'Fundamentos, gestión, catalogación, mediación de lectura, ALFIN y planificación'],
  ['4 bonos estratégicos', 'Proyectos, recursos, animación lectora y calendario 2026'],
  ['100 proyectos bibliotecarios listos', 'Formulados y listos para adaptar a cualquier escuela argentina'],
  ['Banco completo de actividades', '100 propuestas de animación y promoción de la lectura'],
  ['100 recursos y herramientas', 'Softwares, bases de datos libres, plantillas y formularios'],
  ['Calendario Bibliotecario 2026', 'Efemérides, campañas y propuestas mes a mes, editable'],
  ['Plantillas editables', 'Proyectos, presupuestos, catalogación y mediación'],
  ['Casos reales resueltos', 'Con datos del campo bibliotecario escolar argentino'],
  ['Normativa IFLA y contexto argentino', 'Estándares internacionales aplicados a la realidad local'],
  ['Acceso inmediato', 'Descarga directa en menos de 5 minutos'],
  ['Acceso de por vida y actualizaciones', 'Sin costos adicionales'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios'],
];
